import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function PaymentResult() {
  const { result } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { clearCart } = useStore();
  const [status, setStatus] = useState("checking");

  const sessionId = params.get("session_id");

  useEffect(() => {
    if (result !== "success") {
      setStatus("cancel");
      return;
    }
    if (!sessionId) { setStatus("error"); return; }

    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          clearCart();
          setStatus("paid");
          setTimeout(() => navigate(`/order/${data.order_id}`), 1200);
          return;
        }
        if (data.status === "expired" || attempts > 12) {
          setStatus("timeout");
          return;
        }
      } catch {
        if (attempts > 12) { setStatus("error"); return; }
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [result, sessionId]); // eslint-disable-line

  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center">
      {status === "checking" && (
        <>
          <Loader2 size={48} className="mx-auto text-[#C2410C] animate-spin" />
          <h1 className="font-display text-2xl font-bold text-[#1F130B] mt-5">Confirming your payment...</h1>
          <p className="text-[#6B5B52] mt-2">Please wait, do not close this window.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 size={54} className="mx-auto text-[#15803D]" />
          <h1 className="font-display text-2xl font-bold text-[#1F130B] mt-5">Payment Successful!</h1>
          <p className="text-[#6B5B52] mt-2">Redirecting to your order confirmation...</p>
        </>
      )}
      {(status === "cancel" || status === "timeout" || status === "error") && (
        <>
          <XCircle size={54} className="mx-auto text-[#C2410C]" />
          <h1 className="font-display text-2xl font-bold text-[#1F130B] mt-5">
            {status === "cancel" ? "Payment Cancelled" : status === "timeout" ? "Payment Pending" : "Something went wrong"}
          </h1>
          <p className="text-[#6B5B52] mt-2">
            {status === "cancel" ? "Your payment was cancelled. Your cart is still saved." : "We couldn't confirm your payment yet. If money was deducted, contact us on WhatsApp."}
          </p>
          <div className="mt-6 flex gap-3 justify-center">
            <Link to="/checkout" className="rounded-full bg-[#C2410C] text-white font-semibold px-6 py-3">Try Again</Link>
            <Link to="/shop" className="rounded-full border-2 border-[#1C120C] text-[#1C120C] font-semibold px-6 py-3">Back to Shop</Link>
          </div>
        </>
      )}
    </div>
  );
}
